(function(angular){
    'use strict';

    angular.module('aprima-provider-api').factory('GeneralNotesRepository', [
        '$q',
        'AprimaCache',
        'AprimaRestangular',
        GeneralNotesRepository
    ]);

    function GeneralNotesRepository(
        $q,
        AprimaCache,
        AprimaRestangular
    ) {
        var service = {
            search: search,
            getGeneralNoteType: getGeneralNoteType,
            saveGeneralNoteTypeSetting: saveGeneralNoteTypeSetting,
        };

        var generalNoteTypeCache = AprimaCache.Default;

        return service;

        function search(searchText, generalNoteTypeId, includeInactive) {
            var promise = AprimaRestangular.get()
                .all('general-notes')
                .getList({
                    searchText: searchText,
                    generalNoteTypeUid: generalNoteTypeId,
                    includeInactive: includeInactive,
                });

            return promise;
        }

        function getGeneralNoteType(noteTypeOrId) {
            var cachedItem = generalNoteTypeCache.getClone(noteTypeOrId);
            if(cachedItem) {
                return $q.when(cachedItem);
            }

            var promise = AprimaRestangular.get()
                .all('general-note-types')
                .get(noteTypeOrId)
                .then(function(data) {
                    if(!data) {
                        return $q.reject('Could not retrieve GeneralNoteType');
                    }

                    if(data.plain) {
                        data = data.plain();
                    }
                    generalNoteTypeCache.put(noteTypeOrId, data);
                    return data;
                });

            return promise;
        }

        function saveGeneralNoteTypeSetting(noteTypeKey, generalNoteType) {
            var promise = AprimaRestangular.get()
                .one('settings', 'general-note-types')
                .customPUT({
                    NoteTypeKey: noteTypeKey,
                    GeneralNoteType: generalNoteType,
                })
                .then(function(data) {
                    if(data && data.NoteTypeKey && data.GeneralNoteType) {
                        generalNoteTypeCache.put(data.NoteTypeKey, data.GeneralNoteType);
                    }
                    else {
                        generalNoteTypeCache.remove(noteTypeKey);
                    }

                    return data;
                });

            return promise;
        }
    }
})(window.angular);
